import { FC } from 'react';
import {
  getFileTypeFromName,
  getFileTypeIcon,
  formatFileSize,
} from '../../lib/fileUtils';

interface FileInfoDisplayProps {
  fileName?: string | null;
  mediaId?: string | null;
  mediaUrl?: string | null;
  fileSize?: number | null;
}

const FileInfoDisplay: FC<FileInfoDisplayProps> = ({
  fileName,
  mediaId,
  mediaUrl,
  fileSize,
}) => {
  // Check if we have valid file data (handle null, undefined, and empty strings)
  const hasFileName = fileName && fileName.trim() !== '';
  const hasMediaId = mediaId && mediaId.trim() !== '';

  if (!hasFileName && !hasMediaId) {
    return (
      <div className="mt-2 text-small-caption text-neutral-110">
        No file uploaded
      </div>
    );
  }

  const fileType = hasFileName ? getFileTypeFromName(fileName!) : 'unknown';
  const FileTypeIcon = getFileTypeIcon(fileType);
  const displayUrl = mediaUrl && mediaUrl.trim() !== '' ? mediaUrl : undefined;

  return (
    <div className="mt-2 flex items-center space-x-2">
      <FileTypeIcon className="h-5 w-5 flex-shrink-0 text-secondary-100" />
      <div className="flex flex-col">
        {displayUrl ? (
          <a
            href={displayUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-caption font-medium text-secondary-100 hover:text-secondary-125 hover:underline"
          >
            {hasFileName ? fileName : 'File'}
          </a>
        ) : (
          <span className="text-caption font-medium text-neutral-150">
            {hasFileName ? fileName : 'File'}
          </span>
        )}
        {fileSize && (
          <span className="text-small-caption text-neutral-110">
            {formatFileSize(fileSize)}
          </span>
        )}
      </div>
    </div>
  );
};

export default FileInfoDisplay;
